import { render, staticRenderFns } from "./SortTab.vue?vue&type=template&id=0a58773f&"
import script from "./SortTab.vue?vue&type=script&lang=js&"
export * from "./SortTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports